export default __webpack_public_path__ + "static/media/aviator_glasses.c31b2df4.jpg";